import * as Sentry from "@sentry/browser";

import { query, storage } from "sinao-corejs";
import { reformatIsoStringToDate, isToday, addTimeToDate, dispatchEvent, isEmpty } from "../mixins/methods";
import { convertNumberToString, convertStringToNumber } from "../mixins/filters";
import { formatTableToApi, formatApiToTable, formatHeadersToApi } from "../mixins/table";
import vatExoneration from "../dummy/vatExoneration.json";
import { LayoutPlugin } from "bootstrap-vue";
import {store} from "@/store/store";
import { getToken } from "sinao-corejs";
import i18n from "@/i18n";

const home = {
	state: () => ({
		loading: true,
		isEditable: true,
		force: false,
		admin: false,
		logoURL: null,
		removePreview: true,
		eventContact:false,
		logoBinary: null,
		bankdetails: [],
		showDetails: false,
		showBillingPopover: false,
		showDownpaymentTable: false,
		showDownpaymentWithoutInvoice: false,
		writtingDate: null,
		deliveredAt: null,
		commercialvalidityDeadline: null,
		billingNumber: "FAC00001",
		details: "",
		commitment_number:"",
		selectedRIB: null,
		title: "",
		paymentTextDaysTemplate: "",
		paymentTextNowTemplate: "",
		paymentTextDays: "",
		//paymentMethods: "", // => computed
		//paymentDelay: 30, // => computed
		paymentDelayConfig: 30,
		paymentDelayClient: null,
		paymentMethodsClient: null,
		paymentMethodsConfig: ["virement bancaire", "chèque"], // can be array or string
		vatExonerationReason: vatExoneration[0].reason,
		vatExonerationArticle: vatExoneration[0].article,
		mention: "",
		mentionAsDefault: false,
		penalityAmount: 40,
		penalityPercentage: 10,
		showSaveBillingModal: false,
		showCreateOrganizationModal:false,
		showCreatePersonModal:false,
		showEditAddressModal:false,
		showEditEstablishmentContactModal: false,
		showRegisterModal: false,
		loadedDocument: null,
		lastDocument: null,
		savingDocument: false,
		penalityTextTemplate: "Taux de pénalités exigibles de plein droit et sans rappel préalable en cas de paiement à une date ultérieure à celle figurant sur la facture %s %%: ",
		indemnityTextTemplate: "Indemnité forfaitaire pour frais de recouvrement en cas de paiement à une date ultérieure à celle figurant sur la facture : %s €. Si les frais de recouvrement sont supérieurs à ce montant, une indemnisation complémentaire sera due, sur présentation des justificatifs.",
		shlould_notify_payment_methods_period: false,
		is_superadmin: false,
		token: getToken()
	}),
	mutations: {
		loading(state, payload) {
			state.loading = payload;
		},
		isEditable(state, payload) {
			state.isEditable = payload;
		},
		force(state, payload) {
			state.force = payload;
		},
		admin(state, payload) {
			state.admin = payload;
		},
		removePreview(state, payload) {
			state.removePreview = payload;
		},
		logoURL(state, payload) {
			state.logoURL = payload;
		},
		logoBinary(state, payload) {
			state.logoBinary = payload;
		},
		bankdetails(state, payload) {
			if (Array.isArray(payload)) {
				state.bankdetails = payload;
			} else {
				state.bankdetails.push(payload);
			}
		},
		showDetails(state, payload) {
			state.showDetails = payload;
		},
		showBillingPopover(state, payload) {
			state.showBillingPopover = payload;
		},
		showDownpaymentTable(state, payload) {
			state.showDownpaymentTable = payload;
		},
		showDownpaymentWithoutInvoice(state, payload) {
			state.showDownpaymentWithoutInvoice = payload;
		},
		writtingDate(state, payload) {
			state.writtingDate = payload;
		},
		deliveredAt(state, payload) {
			state.deliveredAt = payload;
		},
		commercialvalidityDeadline(state, payload) {
			state.commercialvalidityDeadline = payload;
		},
		billingNumber(state, payload) {
			state.billingNumber = payload;
		},
		details(state, payload) {
			state.details = payload.replace(/\\/g, "");
		},
		commitment_number(state, payload) {
			state.commitment_number = payload;
		},
		is_superadmin(state, payload) {
			state.is_superadmin = payload;
		},
		title(state, payload) {
			state.title = payload ? payload.replace(/\\/g, "") : "";
		},
		selectedRIB(state, payload) {
			state.selectedRIB = payload;
		},
		paymentTextDaysTemplate(state, payload) {
			state.paymentTextDaysTemplate = payload;
		},
		paymentTextNowTemplate(state, payload) {
			state.paymentTextNowTemplate = payload;
		},
		paymentTextDays(state, payload) {
			state.paymentTextDays = payload;
		},
		/*
		paymentMethods(state, payload) {
			if (Array.isArray(payload)) {
				state.paymentMethods = payload.join(", ");
			} else {
				state.paymentMethods = payload;
			}
		},
		paymentDelay(state, payload) {
			state.paymentDelay = payload;
		},
		*/
		paymentDelayConfig(state, payload) {
			state.paymentDelayConfig = payload;
		},
		paymentDelayClient(state, payload) {
			state.paymentDelayClient = payload;
		},
		paymentMethodsClient(state, payload) {
			if (Array.isArray(payload)) {
				if (payload.length > 1) {
					state.paymentMethodsConfig = payload.join(", ");
				} else {
					state.paymentMethodsConfig = payload[0];
				}
			} else {
				state.paymentMethodsClient = payload;
			}
		},
		paymentMethodsConfig(state, payload) {
			if (Array.isArray(payload)) {
				if (payload.length > 1) {
					state.paymentMethodsConfig = payload.join(", ");
				} else {
					state.paymentMethodsConfig = payload[0];
				}
			} else {
				state.paymentMethodsConfig = payload;
			}
		},
		vatExonerationReason(state, payload) {
			state.vatExonerationReason = payload;
		},
		vatExonerationArticle(state, payload) {
			state.vatExonerationArticle = payload;
		},
		mention(state, payload) {
			state.mention = payload;
		},
		mentionAsDefault(state, payload) {
			state.mentionAsDefault = payload;
		},
		penalityAmount(state, payload) {
			state.penalityAmount = payload;
		},
		penalityPercentage(state, payload) {
			state.penalityPercentage = payload;
		},
		showSaveBillingModal(state, payload) {
			state.showSaveBillingModal = payload;
		},
		showCreateOrganizationModal(state, payload) {
			state.showCreateOrganizationModal = payload;
		},
		showEditEstablishmentContactModal(state, payload) {
			state.showEditEstablishmentContactModal = payload;
		},
		showEditAddressModal(state, payload) {
			state.showEditAddressModal = payload;
		},
		showRegisterModal(state, payload) {
			state.showRegisterModal = payload;
		},
		lastDocument(state, payload) {
			state.lastDocument = payload;
		},
		loadedDocument(state, payload) {
			state.loadedDocument = payload;
		},
		savingDocument(state, payload) {
			state.savingDocument = payload;
		},
		penalityTextTemplate(state, payload) {
			const text = payload === null ? "" : payload.replace("%%", "%");
			state.penalityTextTemplate = text;
		},
		indemnityTextTemplate(state, payload) {
			state.indemnityTextTemplate = payload?? "";
		},
		shlouldNnotifyPaymentMethodsPeriod(state, payload) {
			state.shlould_notify_payment_methods_period = payload;
		},
		showCreatePersonModal(state, payload) {
			state.showCreatePersonModal = payload;
		},
		eventContact(state, payload) {
			state.eventContact = payload;
		}
	},
	getters: {
		paymentDelay(state) {
			return state.paymentDelayClient ?? state.paymentDelayConfig;
		},
		paymentMethods(state) {
			const methods = state.paymentMethodsClient ?? state.paymentMethodsConfig;
			return Array.isArray(methods) ? methods.join(",") : methods;
		},
		isAmountValid(state, getters) {
			if (state.loadedDocument?.credit_note_id) {
				return getters.totals.table.inclTax <= 0  ? { value: true, message: "" } : { value: false, message: "Un Avoir ne peut avoir un montant positif." };
			} else {
				return getters.totals.table.inclTax >= 0 ? { value: true, message: "" } : { value: false, message: "Conformément à la loi anti-fraude à la TVA, il est impossible de créer une facture négative (avoir) dans Sinao sans facture initiale. L’avoir sert à annuler une facture préalablement enregistrée (écrite dans Sinao ou importée)." };
			}
		}
	},
	actions: {
		redirectToListing({ rootState }) {
			const { page, recurring } = rootState;

			if (window.parent) {
				let accountingPage = "billing";

				if (recurring.isRecurringInvoice) {
					accountingPage = "autoinvoicing";
				} else {
					accountingPage = page.type === "invoices" ? "billing" : "quote";
				}

				// Remove onbeforeunload
				window.onbeforeunload = null;

				// Redirect
				dispatchEvent({
					modalName: null,
					source: "billing",
					action: "return_to",
					data: { page: accountingPage }
				});	
			}
		},
		redirectToWriting({ rootState }) {
			const { page, recurring } = rootState;

			let accountingPage = "editbilling";

			if (window.parent) {
				
				if (recurring.isRecurringInvoice) {
					accountingPage += "/new-invoice-true";
				} else if (page.type === "quotes") {
					accountingPage += "/new-quote";
				} else {
					accountingPage += "/new-invoice";
				}

				// Remove onbeforeunload
				window.onbeforeunload = null;

				// Redirect
				dispatchEvent({
					modalName: null,
					source: "billing",
					action: "return_to",
					data: { page: accountingPage }
				});	
			}
		},
		async nextDocument({ rootState }, writtenAt = null) {
			try {
				const { app, page } = rootState;

				const response = await query({
					operationId: `app.documents.sales.${page.type}.nextnumber`,
					params: {
						appId: app.id,
						written_at: writtenAt
					}
				});

				return response;
			} catch (error) {
				console.error(error);

				process.env.NODE_ENV === "production" &&
					Sentry.captureException(error, {
						contexts: {
							error: error?.response?.data
						}
					});
			}
		},
		async relationships({ commit, rootState }, { contact, search } = {}) {
			try {
				const { app } = rootState;

				if (contact === null && search === null) {
					const storeRelationships = await storage.get("contacts", app.id);
					// Return the data in the store if it's available
					if (storeRelationships) {
						commit("contacts", storeRelationships.data);
					}
				}

				const response = await query({
					operationId: "app.contacts.relationships.list",
					params: {
						appId: app.id,
						"expand[0]": "contact",
						"expand[1]": "contact.establishments",
						"expand[2]": "contact.establishments.contacts",
						"order[0][name]": "id",
						"order[0][direction]": "DESC",
						limit: search?.split(" ").length >=2 ? 30 : 10,
						search
					}
				});

				if (response) {
					const { data } = response;
					const contacts = [];

					if (data) {
						data.forEach(relationship => {
							const { contact, discount, tags, details, payment_methods: paymentMethodsClient, payment_period: paymentDelayClient } = relationship ?? {};

							if (contact) {
								// add contacts to establishment if none
								contact.establishments.forEach(establishment => {
									if (!establishment.contacts)
										establishment.contacts = [];
								});
								contacts.push({
									...contact,
									discount,
									tags,
									details,
									paymentDelayClient,
									paymentMethodsClient
								});
							}
						});

						// Store to cache before any changes
						if (search === null) {
							storage.set("contacts", [...contacts], 3600, app.id);
						}

						commit("contacts", contacts);

						if (contact) {
							const detailed_contact = contacts.find(c => c.id === contact.id)
							
							if (detailed_contact !== undefined) {
								// called by enterceptEvent::REFRESH_RELATIONSHIPS
								commit("contactInfos", {
									...detailed_contact,
									establishment_id: detailed_contact.establishments[0]?.id ?? null,
									address: detailed_contact.establishments[0]?.place ? detailed_contact.establishments[0]?.place?.exported_address?.trim() : "",
									location: detailed_contact.establishments[0]?.place ? ((detailed_contact.establishments[0]?.place?.postal_code ?? "") + " " + (detailed_contact.establishments[0]?.place?.locality ?? "") + " " + (detailed_contact.establishments[0]?.place?.country ?? "")).trim() : ""
								});
							} else {
								commit("contactInfos", {
									...contact,
									//address: null,
									//location: null,
									establishment_id: contact.establishments[0]?.id ?? null,
									address: contact.establishments[0].place ? contact.establishments[0].place.exported_address.trim() : "",
									location: contact.establishments[0].place ? (contact.establishments[0].place.postal_code + " " + contact.establishments[0].place.locality + " " + contact.establishments[0].place.country).trim() : "",
									modal: true
								});
							}
						}
					}
				}
			} catch (error) {
				throw new Error(error);
			}
		},
		async relationshipsSearch({ commit, rootState }, search) {
			try {
				const { app } = rootState;

				return query({
					operationId: "app.contacts.relationships.list",
					params: {
						appId: app.id,
						"expand[0]": "contact",
						"expand[1]": "contact.establishments",
						"expand[2]": "contact.establishments.contacts",
						"order[0][name]": "id",
						"order[0][direction]": "DESC",
						search,
						limit: 50
					}
				}).then(({ data }) => {
					commit("relationships", data);
				});
			} catch (error) {
				throw new Error(error);
			}
		},
		async bankdetails({ commit, rootState }) {
			const { app } = rootState;

			try {
				const response = await query({
					operationId: "app.documents.sales.bankdetails.list",
					params: {
						appId: app.id
					}
				});

				commit("bankdetails", response.data);

				return response.data;
			} catch (error) {
				throw new Error(error);
			}
		},
		async lastDocument({ commit, rootState, state, dispatch, rootGetters }) {
			const { app, page } = rootState;

			query({
				operationId: "account.get",
			}).then(me => {
				commit("is_superadmin", me.is_superadmin ?? false);
			});

			try {
				const response = await query({
					operationId: `app.documents.sales.${page.type}.list`,
					params: {
						appId: app.id,
						"filters[0][name]": "status",
						"filters[0][comparator]": "!=",
						"filters[0][value]": "draft",
						"filters[1][name]": "imported_at",
						"filters[1][comparator]": "=",
						"filters[1][value]": "null",
						limit: 1
					}
				});
				if (response.data.length > 0) {
					commit("lastDocument", response.data[0]);
					commit("shlouldNnotifyPaymentMethodsPeriod", false);

					if (!state.loadedDocument) { // update lang & payment_period & payment_methods on last document values
						dispatch("setPrintableLangByDocument", response.data[0]);
						commit("setPreviousPrintableLang", response.data[0]?.metadata?.lang?.key ?? null);

						if (response.data[0].payment_period)
							commit("paymentDelayConfig", response.data[0].payment_period);

						if (response.data[0]?.payment_methods )
							commit("paymentMethodsConfig", response.data[0].payment_methods);
					}




					return response.data[0];
				} else {
					return null;
				}
			} catch (error) {
				console.error(error);

				process.env.NODE_ENV === "production" &&
					Sentry.captureException(error, {
						contexts: {
							error: error?.response?.data
						}
					});
			}
		},
		async loadDocument({ commit, dispatch, state, rootState, rootGetters }, { data = null, force = false }) {
			const { app, page, settings } = rootState;

			let response = null;
			commit("savingDocument", true);
			
			if (data) {
				response = {
					...data
				};
				commit("loadedDocument", response);
			} else {
				try {
					response = await query({
						operationId: `app.documents.sales.${page.type}.get`,
						params: {
							id: app.documentId,
							appId: app.id,
							"expand[0]": "balance",
							"expand[1]": "author.name",
							"expand[2]": "payments",
							"expand[3]": "transactions",
							"expand[4]": "content",
							"expand[5]": "downpayments",
							"expand[6]": "customer.establishments",
							"expand[7]": "customer.establishments.contacts",
							"expand[8]": "is_editable",
							"expand[9]": "customer.relationship",
							"expand[10]": "third_account_contact.establishments"
						}
					});

					commit("loadedDocument", response);
					commit("shlouldNnotifyPaymentMethodsPeriod", false);
					dispatch("setPrintableLangByDocument", response);
					commit("setPreviousPrintableLang", response.metadata?.lang?.key ?? null);

				} catch (error) {
					console.error(error);

					process.env.NODE_ENV === "production" &&
						Sentry.captureException(error, {
							contexts: {
								error: error?.response?.data
							}
						});

					// If the document doesn't exist
					this._vm.$bvToast.toast("Document introuvable, redirection dans 3 secondes.", {
						title: "Erreur de chargement",
						variant: "danger",
						solid: true
					});

					//setTimeout(() => {
					//	dispatch("redirectToListing");
					//}, 3 * 1000);

					return;
				}
			}

			if (response) {
				state.force = force;

				if (force) {
					state.isEditable = true;
				} else {
					state.isEditable = response?.is_editable;
				}

				if (response.payment_methods)
					commit("paymentMethodsConfig", response.payment_methods);
					commit("paymentMethodsClient", response.payment_methods);
				if (response.payment_period !== undefined && response.payment_period !== null) {
					commit("paymentDelayConfig", response.payment_period);
					commit("paymentDelayClient", response.payment_period);
				}


				// set the details
				let details = "";
				if (response.details && response.details.length > 0)
					details = response.details;
				// update 2023-12-05 : do not load relationship.details if document is already recorded 
				//else if (response.customer?.relationship)
				//	details = response.customer.relationship.details?? "";

				state.billingNumber = response?.number ?? "Brouillon";
				state.details = details; // details de "note"
				state.title = response?.title;
				state.reference = response?.reference;
				//state.paymentDelayConfig = response?.payment_period ?? 30; // commented to test if no more "jump back to 30"
				commit('commitment_number', response?.commitment_number ?? "");

				if (response?.payment_methods)
					commit("paymentMethodsConfig", response.payment_methods)

				if(response?.legal_notice)
					state.mention = response?.legal_notice;

				if (details.length > 0) {
					state.showDetails = true;
					dispatch("checkForRecurringPeriodVarInDetails", details);
				}

				if (response?.bank_details_id) {
					state.selectedRIB = {
						id: response?.bank_details_id
					};
				}

				dispatch("createDownpaymentRows", response?.downpayments);

				if (response?.delivered_at) {
					const value = response?.delivered_at;

					state.deliveredAt = response?.delivered_at ? reformatIsoStringToDate(value) : null;
				}

				if (response?.commercialvalidity_deadline) {
					const value = response?.commercialvalidity_deadline;

					state.commercialvalidityDeadline = value ? reformatIsoStringToDate(value) : null;
				}

				if (response?.written_at) {
					state.writtingDate = response?.written_at ? reformatIsoStringToDate(response?.written_at) : null;
				}

				if (response?.contact_infos && response?.contact_infos.id) {
					// add establishment_contact_id property to contactInfos customer.establishments.contacts
					let _establishment_contact_id = null;
					let _email = null;
					if (response.contact_infos.establishment_id || response.contact_infos.email) {
						response.customer.establishments.some(establishment => {
							const _contact = establishment.contacts.find(estaContact => estaContact.email === response.contact_infos.email);
							if (_contact !== undefined) {
								_establishment_contact_id = _contact.id;
								_email = _contact.email;
								return true;
							}
						})
					}
					commit("contactInfos", Object.assign({}, response.contact_infos, {
						customerName: response?.customer?.name,
						image: response?.customer?.image,
						establishments: response?.customer?.establishments,
						establishment_contact_id: _establishment_contact_id,
						establishment_id: response.contact_infos.establishment_id,
						email: _email
					}));

				}

				if (response?.third_account) {
					commit("thirdAccount", {
						...response?.third_account,
						customerName: response?.third_account?.name,
						image: response?.third_account?.image,
						establishments: response?.third_account_contact?.establishments
					});
				}

				if (response?.tags) {
					const formattedTags = response?.tags.map(tag => {
						return {
							text: tag
						};
					});

					commit("tags", formattedTags);
				}

				
				if (response?.vat_exemption?.exempted === true) {
					commit("selectedVatValue", 0);
					// _exemption_reason is the key of Object rootGetters.config?.accounting?.vat_exemption
					const _exemption_reason = response?.vat_exemption?.reason && !rootGetters.config?.accounting?.vat_exemption[response.vat_exemption.reason]?.deleted_at
						? response.vat_exemption.reason
						: "null"
					commit("vatExonerationReason", _exemption_reason);
					//set the vat exemption article based on current config
					const _article = Object.hasOwn(rootGetters.config?.accounting?.vat_exemption, _exemption_reason)
						? rootGetters.config?.accounting?.vat_exemption?.[_exemption_reason]?.text
						: response?.vat_exemption?.article
					commit("vatExonerationArticle", _article);
				}

				if (response?.foreign_currency)
					dispatch('initCurrencyByIso', { isoCode: response.foreign_currency, from: "loadDocument" });

				commit("setPrintableLang", response?.metadata?.lang?.key ? response.metadata.lang : { key: "fr", name: "Français" });

				commit(
					"depositAmount",
					response?.downpayment_request?.amount
						? convertNumberToString(response?.downpayment_request?.amount / 100)
						: null
				);

				commit(
					"depositPercent",
					response?.downpayment_request?.percent
						? convertNumberToString(response?.downpayment_request?.percent / 100)
						: null
				);

				commit(
					"depositValue",
					response?.downpayment_request?.value ? response?.downpayment_request?.value / 100 : null
				);

				if (response?.downpayment_request?.amount || response?.downpayment_request?.percent) {
					commit("showDownpaymentWithoutInvoice", true);
				}

				commit("couponCode", response?.discount?.name ?? null);

				if (response?.discount?.percent) {
					commit("couponCodeType", "%");
					commit(
						"couponCodePercent",
						response?.discount?.percent ? convertNumberToString(response?.discount?.percent / 100) : null
					);
					commit("couponCodeValue", convertNumberToString(rootState.vat.couponCodePercent, 2));
				} else {
					if (response?.discount?.amount) {
						commit("couponCodeType", rootState.currency);
						commit(
							"couponCodeAmount",
							response?.discount?.amount ? convertNumberToString(response?.discount?.amount / 100) : null
						);
						commit("couponCodeValue", convertNumberToString(rootState.vat.couponCodeAmount, 2));
					}
				}

				if (response?.columns) {
					let designationColumnFound = false;

					Object.entries(response?.columns).forEach(([key, value]) => {
						if (key === "designation") {
							designationColumnFound = true;
						}

						if (value !== false) {
							commit("renameHeaderByKey", { key, value });
							commit("enableHeaderByKey", key);
						}

						if (value === false && key !== "designation") {
							commit("disableHeaderByKey", key);
						}
					});

					// In case the designation column disappear for some reason or is set to false
					if (!designationColumnFound || isEmpty(response?.columns.designation)) {
						commit("enableHeaderByKey", "designation");
					}
				}

				let table = {
					sections: []
				};

				if (response?.content) {
					const foreign_currency_rate = response.amount_net_foreign_currency
						? (response.amount + response.amount_tax) / response.amount_net_foreign_currency
						: 1;
					table = formatApiToTable(response.content, foreign_currency_rate.toFixed(12));
				}
				commit("table", table);
			}
			commit("savingDocument", false);
			
			return response;
		},
		buildDocument({ rootState, rootGetters, getters, state }) {
			const { home, vat, downpayment, billing, tags, settings } = rootState;

			// Check if the document is empty
			/*
			var is_credit_note = !( !home?.loadedDocument || home?.loadedDocument?.credit_note_id === null );
			if (!is_credit_note && rootGetters.totals.table.exclTax < 0) {
				return this._vm.$bvToast.toast(
					"Impossible d'enregistrer un document avec un montant inférieur ou égal à zéro.",
					{
						title: "Erreur d'enregistrement",
						variant: "danger",
						solid: true
					}
				);
			} else if(is_credit_note && rootGetters.totals.table.exclTax >= 0) {
				return this._vm.$bvToast.toast(
					"Impossible d'enregistrer un avoir avec un montant supérieur ou égal à zéro.",
					{
						title: "Erreur d'enregistrement",
						variant: "danger",
						solid: true
					}
				);
			}
			*/

			let writtenAt = null;
			let deliveredAt = null;
			let commercialvalidityDeadline = null;

			if (home?.writtingDate) {
				if (isToday(home.writtingDate)) {
					writtenAt = addTimeToDate(home.writtingDate);
				} else {
					writtenAt = new Date(home.writtingDate).toISOString().replace(".000Z", "Z");
				}
			}

			if (home?.deliveredAt) {
				if (isToday(home.deliveredAt)) {
					deliveredAt = addTimeToDate(home.deliveredAt);
				} else {
					deliveredAt = new Date(home.deliveredAt).toISOString().replace(".000Z", "Z");
				}
			}

			if (home?.commercialvalidityDeadline) {
				if (isToday(home.commercialvalidityDeadline)) {
					commercialvalidityDeadline = addTimeToDate(home.commercialvalidityDeadline);
				} else {
					commercialvalidityDeadline = new Date(home.commercialvalidityDeadline)
						.toISOString()
						.replace(".000Z", "Z");
				}
			}

			let arrayTags = [];

			if (tags?.tags) {
				arrayTags = tags?.tags.map(tag => tag.text);
			}

			// allow no customer, just == because home?.contactInfos can be null or undefined
			const _contactInfos = rootState?.contacts?.contactInfos == null ? null :  Object.assign({}, rootState?.contacts?.contactInfos)
			if (_contactInfos !== null) {
				// prevent sending establishment_id = null if a computed establishment has bee, get
				if (_contactInfos.establishment_id === null && _contactInfos.location.length > 0 && _contactInfos.establishments.length > 0) {
					if (_contactInfos.establishments.length > 1) {
						const _establishment = _contactInfos.establishments.find((establishment) => {
							const _location = establishment.place ?
								((establishment.place.postal_code ?? "") + " " + (establishment.place.locality ?? "") + " " + (establishment.place.country ?? "")).trim()
								: "";
							return _location === _contactInfos.location
						});
						if (_establishment) {
							_contactInfos.establishment_id = _establishment.id;
						}
					} else {
						_contactInfos.establishment_id = _contactInfos.establishments[0].id;
					}
				}
				if (_contactInfos.establishments) {
					delete _contactInfos.establishments;
				}
				if (_contactInfos.third_account) {
					delete _contactInfos.third_account.establishments;
				}

				// prevent "null" in string
				if (_contactInfos.details && (!_contactInfos.details.length || _contactInfos.details.toLowerCase() === "null"))
					_contactInfos.details = null;

				if (_contactInfos.email && (!_contactInfos.email.length || _contactInfos.email.toLowerCase() === "null"))
					_contactInfos.email = null;

				if (_contactInfos.location && (!_contactInfos.location.length || _contactInfos.location.toLowerCase() === "null"))
					_contactInfos.location = null;
			}


			const metadata = state.loadedDocument?.metadata ?? {};
			metadata.lang = getters.computedPrintableLang;
			
			
			const document = {
				currency: settings.currency?.iso,
				tags: arrayTags,
				contact_infos: _contactInfos === null ? null : {
					..._contactInfos
				},
				third_account: rootState.contacts.thirdAccount ? { ...rootState.contacts.thirdAccount } : { ...rootState.contacts.thirdAccount_null },
				details: home.details ?? "",
				title: home.title ?? "",
				payment_period: getters.paymentDelay,
				payment_methods: Array.isArray(getters.paymentMethods) ? getters.paymentMethods.join(",") : getters.paymentMethods,
				legal_notice: home.mention ?? "",
				columns: formatHeadersToApi(rootGetters.enabledHeadersValues),
				vat_exemption: {
					exempted: vat.selectedVatValue === 0,
					reason: home.vatExonerationReason ?? "",
					article: home.vatExonerationArticle ?? ""
				},
				downpayment_request: {
					amount: convertStringToNumber(downpayment.depositAmount) * 100 ?? null,
					percent: convertStringToNumber(downpayment.depositPercent) * 100 ?? null
				},
				content: formatTableToApi(billing.table),
				discount: {
					name: vat.couponCode ?? "",
					amount: vat.couponCodeAmount ? Math.round(convertStringToNumber(vat.couponCodeAmount) * 100) : null,
					percent: vat.couponCodePercent ? Math.round(convertStringToNumber(vat.couponCodePercent) * 100) : null
				},
				written_at: writtenAt,
				delivered_at: deliveredAt,
				commercialvalidity_deadline: commercialvalidityDeadline,
				downpayments: rootGetters.getTableIds ?? [],
				bank_details_id: home.selectedRIB?.id ?? null,
				metadata : metadata,
				commitment_number: home.commitment_number.length ? home.commitment_number : null,
				//customer_establishment_id: rootState.contacts.contactInfos.establishment_id > 0 ? rootState.contacts.contactInfos.establishment_id : null,
			};

			if (!home.isEditable && !home.force) {
				delete document.content;
			}
			
			return document;
		},
		async saveDocument({ dispatch, commit, rootState, state }, token = null) {
			const { home, settings, app, page, recurring } = rootState;

			home.savingDocument = true;

			//console.log("contactInfo ", state.contactInfos);

			// Settings
			try {
				const settingsObj = {
					"template.color-primary": settings?.accentColor?.background,
					"template.color-second": settings?.accentColor?.background,
					"template.color-second-text": settings?.accentColor?.foreground
				};

				if (rootState.vat?.vatValues) {
					settingsObj[`accounting.vat.values`] = rootState.vat?.vatValues;
				}

				if (home?.mentionAsDefault) {
					settingsObj[`accounting.mention.${page.type}`] = home?.mention;
				}

				if (home?.penalityPercentage) {
					settingsObj["accounting.delay.rate.std"] = home?.penalityPercentage;
				}

				if (home?.penalityAmount) {
					settingsObj["accounting.delay.compensation.std"] = home?.penalityAmount;
				}

				if (!home?.logoURL) {
					settingsObj["accounting.printablelogo"] = null;
				}

				if (home?.logoBinary) {
					const formData = new FormData();
					formData.append("value", home.logoBinary);

					await query({
						operationId: "app.settings.update",
						token,
						headers: {
							"Content-Type": "multipart/form-data"
						},
						params: {
							appId: app.id,
							key: "accounting.printablelogo"
						},
						data: formData
					});
				}

				await query({
					operationId: "app.settings.update",
					token,
					params: {
						appId: app.id
					},
					data: { settings: settingsObj }
				});
			} catch (error) {
				console.error(error);

				process.env.NODE_ENV === "production" &&
					Sentry.captureException(error, {
						contexts: {
							error: error?.response?.data
						}
					});
			}

			// Document
			let document = null;
			let response = null;

			/* TODO: deprecated ?
			// create establishment
			if (rootState?.contacts?.contactInfos !== null && rootState?.contacts?.contactInfos.establishment_id === 0 && rootState?.contacts?.contactInfos.address.length)
				await dispatch('createEstablishment'); // TODO deprecated ?

			// create establishment contact
			if (rootState?.contacts?.contactInfos !== null && rootState?.contacts?.contactInfos.establishment_contact_id === 0 && rootState?.contacts?.contactInfos.email.length) {
				if (!rootState?.contacts?.contactInfos.establishment_id)
					await dispatch('createEstablishment');

				await dispatch('createOrUpdateEstablishmentContact'); // TODO deprecated ?
			}
			*/



			try {
				const action = app.documentId ? "update" : "create";

				if (recurring.isRecurringInvoice) {
					document = await dispatch("buildRecurringDocument");
					
					if (document) {
						response = await query({
							operationId: `app.documents.sales.recurringinvoices.${action}`,
							token,
							params: {
								appId: app.id,
								id: app.documentId
							},
							data: {
								...document
							}
						});

						if (response?.id) {
							commit("documentId", response.id);
							commit("loadedDocument", response);
						}

						if (action === "create" || action === "update") {

							dispatchEvent({
								source: "billing",
								action: "trackEvent",
								data: {
									eventName: "app-invoice-autoinvoicing",
									metadata: null,
									document: response,
								}
							});
						}

						dispatch("redirectToListing");
					}
				} else {
					document = await dispatch("buildDocument");
					if (document) {
						response = await query({
							operationId: `app.documents.sales.${page.type}.${action}`,
							token,
							params: {
								appId: app.id,
								id: app.documentId
							},
							data: {
								...document,
								force_sync: true
							}
						});

						if (response?.id) {
							commit("documentId", response.id);
							commit("loadedDocument", response);

							// Show save modal
							if (token === null && !state.removePreview) {
								home.showSaveBillingModal = true;
							} else if (state.removePreview) {
								let description = page.type === "invoices" ? i18n.t("Votre facture a été enregistrée avec succès") : i18n.t("Votre devis a été enregistré avec succès");
								let title = page.type === "invoices" ? i18n.t("Facture enregistrée") : i18n.t("Devis enregistré");

								this._vm.$bvToast.toast(description, {
									title: title,
									variant: "success",
									solid: true
								});

								window.onbeforeunload = null;
							}
						}

						if (action === "create" || action === "update") {
							const eventName = page.type === "invoices" ? `app-invoice-${action}d` : `app-quote-${action}d`;

							dispatchEvent({
								source: "billing",
								action: "trackEvent",
								data: { eventName, metadata: null, document: response }
							});
						}
					}
				}
			} catch (error) {
				console.log(error);

				home.showSaveBillingModal = false;

				const status = error?.response?.status ?? null;
				const tags = {};

				if (status) {
					tags.source = "API";
					tags.status = status;
				}

				process.env.NODE_ENV === "production" &&
					Sentry.captureException(error, {
						// @ts-ignore
						tags,
						contexts: {
							document,
							error: error?.response?.data
						}
					});

				switch (status) {
					case 404:
						this._vm.$bvToast.toast(i18n.t("Erreur #404 : impossible d'enregistrer le document."), {
							title: i18n.t("Erreur d'enregistrement"),
							variant: "danger",
							solid: true
						});
						break;

					case 422:
						// let message = "Les données saisies ne sont pas conformes.";
						if (error?.response?.data?.message === "The given data was invalid." && error?.response?.data?.errors) {
							let message = "";
							const vatErrorReg = /vat_percent$/i;
							for (let key of Object.keys(error.response.data.errors)) {
								if (vatErrorReg.test(key)) {
									message += i18n.t("Au moins un taux de TVA est erroné");
								}
								else if (Array.isArray(error.response.data.errors[key]) && error.response.data.errors[key].find(elem => elem === "validation.exists")) {
									const key_parts = key.split(".");
									if (key_parts.length) {
										message += i18n.t("produit ligne existe pas", {section: (parseInt(key_parts[1]) + 1), line: (parseInt(key_parts[3]) + 1) });
									}
								}
							}
							if (message.length === 0) {
								message = i18n.t("Erreur #422 lors de l’enregistrement de votre document. Veuillez contacter notre Service Client via la bulle de tchat.")
							} 
							this._vm.$bvToast.toast(message, {
								title:  i18n.t("Erreur d'enregistrement"),
								variant: "danger",
								solid: true
							});
						}
						else {
							let _message = "";
							if (/commitment_number/i.test(error?.response?.data?.message)) {
								_message = i18n.t("invalid commitment number");
							}
							else {
								_message = i18n.t("Les données saisies ne sont pas conformes.")
							}

							this._vm.$bvToast.toast(_message, {
								title: i18n.t("Erreur d'enregistrement"),
								variant: "danger",
								solid: true
							});

						}
						break;

					case 429:
						{
							const h = this._vm.$createElement;

							const vNodesMsg = h("div", { class: "text-center " }, [
								i18n.t("Vous avez atteint le nombre maximum de factures que vous pouvez éditer avec cette formule. Mettez à niveau votre formule"),
								h(
									"b-link",
									{
										props: {
											href: `${app.app.url}settings/subscription/select/`,
											target: "_blank"
										}
									},
									i18n.t(" en cliquant ici.")
								)
							]);

							this._vm.$bvToast.toast([vNodesMsg], {
								title: i18n.t("Vous ne pouvez plus faire de facture ce mois-ci"),
								variant: "danger",
								solid: true
							});
						}

						break;

					default:
						this._vm.$bvToast.toast(
							i18n.t("Nous avons rencontré une erreur, réessayez", { status: String(status) }),
							{
								title: i18n.t("Erreur d'enregistrement"),
								variant: "danger",
								solid: true
							}
						);
						break;
				}
			}

			home.savingDocument = false;

			return response;
		},
		downloadInvoice({ rootState }, { token, id }) {
			const { app } = rootState;

			return query({
				operationId: "app.documents.sales.invoices.download",
				token,
				params: {
					appId: app.id,
					ids: [id]
				}
			});
		}
	}
};

export default home;
